import { useSelector } from 'react-redux';

import { currentAccountSelector } from '../store/user/selectors';

export const AGENT_PERMISSION_RESOURCE_LIBRARY = 'agentResourceLibrary';
export const AGENT_PERMISSION_MEDIA_LIBRARY = 'agentMediaLibrary';
export const AGENT_PERMISSION_DOCUMENT_LIBRARY = 'agentDocumentLibrary';
export const AGENT_PERMISSION_ITINERARIES = 'agentItineraries';
export const AGENT_PERMISSION_CONTENT_LIBRARY = 'agentContentLibrary';
export const AGENT_PERMISSION_WHITE_LABELING = 'agentWhiteLabeling';
export const AGENT_PERMISSION_SHARE_WITH_AGENT = 'agentShareWithAgent';
export const AGENT_PERMISSION_TRANSLATE_SERVICE = 'agentTranslateService';
export const AGENT_PERMISSION_CUSTOM_DOMAIN = 'agentCustomDomain';
export const PERMISSION_GUEST_PORTAL = 'guestPortal';
export const PERMISSION_REMOVE_BRANDING = 'removeBranding';
export const PERMISSION_ALL_FEATURES = 'allFeatures';

const NON_ALL_FEATURES_PERMISSIONS = [PERMISSION_REMOVE_BRANDING];

export const useIsSubscriptionAllowedExternal = (account, accountType, permissionName) => {
  return Boolean(useSubscriptionAllowedExternal(account, accountType, permissionName));
};

export const checkSubscriptionPermissions = (subscriptions, permissionName) => {
  if (!subscriptions) return 0;
  if (NON_ALL_FEATURES_PERMISSIONS.includes(permissionName)) return subscriptions[permissionName];
  if (subscriptions[PERMISSION_ALL_FEATURES]) return Infinity;

  return subscriptions[permissionName];
};

export const isCheckSubscriptionPermissions = (subscriptions, permissionName) => {
  return Boolean(checkSubscriptionPermissions(subscriptions, permissionName));
};

export const useSubscriptionAllowedExternal = (account, accountType, permissionName) => {
  if (!account) return 0;
  if (account.type !== accountType) return Infinity;

  return checkSubscriptionPermissions(account.subscriptions, permissionName);
};

export const useSubscriptionAllowed = (accountType, permissionName) => {
  const account = useSelector(currentAccountSelector);
  return useSubscriptionAllowedExternal(account, accountType, permissionName);
};

export const useIsSubscriptionAllowed = (accountType, permissionName) => {
  return Boolean(useSubscriptionAllowed(accountType, permissionName));
};
